const getAuthKey = `query bpointTransaction($authKeyInput: authKeyInput) {
    authKey(authKeyInput: $authKeyInput) {
    authKey
    authToken
    }
    }`;

export {
    getAuthKey
};